import { ArrowDown, ArrowUp, Copy, Trash2 } from "lucide-react";
import { MoreActionsMenu } from "components/common/MoreActionsMenu";
import type { MoreActionsMenuGroup, MoreActionsMenuItem } from "components/common/MoreActionsMenu";
import { BudgetRowActionsProps } from "./BudgetRowActions.types";

const iconClass = "h-4 w-4 shrink-0";

/**
 * Per-row overflow menu for the detailed budget grid. Consolidates reorder,
 * duplicate, and delete behind a single ⋯ trigger at the row's trailing edge.
 */
export const BudgetRowActions = ({
  onMoveUp,
  onMoveDown,
  onDuplicate,
  onDelete,
  canMoveUp = false,
  canMoveDown = false,
  disabled,
  disabledTitle,
}: BudgetRowActionsProps) => {
  const structureItems: MoreActionsMenuItem[] = [];
  const lockedTitle = disabled ? disabledTitle : undefined;

  if (onMoveUp && onMoveDown) {
    structureItems.push(
      {
        id: "move-up",
        label: "Move up",
        icon: <ArrowUp className={iconClass} />,
        disabled: disabled || !canMoveUp,
        title: lockedTitle,
        onSelect: onMoveUp,
      },
      {
        id: "move-down",
        label: "Move down",
        icon: <ArrowDown className={iconClass} />,
        disabled: disabled || !canMoveDown,
        title: lockedTitle,
        onSelect: onMoveDown,
      }
    );
  }

  if (onDuplicate) {
    structureItems.push({
      id: "duplicate",
      label: "Duplicate",
      icon: <Copy className={iconClass} />,
      disabled,
      title: lockedTitle,
      onSelect: onDuplicate,
    });
  }

  const groups: MoreActionsMenuGroup[] = [];

  if (structureItems.length > 0) {
    groups.push({ id: "structure", items: structureItems });
  }

  groups.push({
    id: "destructive",
    items: [
      {
        id: "delete",
        label: "Delete",
        icon: <Trash2 className={iconClass} />,
        variant: "destructive",
        disabled,
        title: lockedTitle,
        onSelect: onDelete,
      },
    ],
  });

  return (
    <MoreActionsMenu
      label="Line actions"
      align="end"
      disabled={disabled}
      disabledTitle={disabledTitle}
      groups={groups}
      onOpenChange={(open) => {
        if (open) {
          (document.activeElement as HTMLElement | null)?.blur();
        }
      }}
    />
  );
};
